export default __webpack_public_path__ + "static/media/1.914d7da5.png";